export const paginationVariables = /* GraphQL */ `
  $first: Int,
  $after: String
`
